import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { verifyPermissionForRolesUtil } from '../_utils/verify-permission-for-roles.util';
import { getObservableTokenExpiredUtil } from '../_utils/get-observable-token-expired.util';
import { combineLatestWith, map, tap } from 'rxjs';

export const verifyRolesGuardFactory = (...roles: string[]) => {
  const guardGenerated: CanActivateFn = (route, state) => {
    const router = inject(Router);

    const isAuthRoute = state.url.startsWith('/auth');
    const hasPermission$ = verifyPermissionForRolesUtil(...roles);
    const isTokenExpired$ = getObservableTokenExpiredUtil();

    const navigateToAuth = () => {
      router.navigate(['auth', 'login'], {
        queryParams: { redirectUrl: state.url },
        queryParamsHandling: 'merge',
      });
    };

    return isTokenExpired$.pipe(
      combineLatestWith(hasPermission$),
      tap(([isTokenExpired, hasPermission]) => {
        if (isTokenExpired || !hasPermission) {
          navigateToAuth();
        }
      }),
      map(([isTokenExpired, hasPermission]) => !isTokenExpired && hasPermission)
    );
  };

  return guardGenerated;
};
